import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { useNavigate } from 'react-router-dom';
import logoPlaceholder from '../assets/logo_placeholder.png';
import { Button } from './ui/button';
import { MapPin } from 'lucide-react';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/competitors');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getInitials = (username) => {
    return username ? username.slice(0, 2).toUpperCase() : 'U';
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={handleLogoClick}
              >
                <MapPin className="h-6 w-6 text-primary" />
                <span className="text-xl font-bold">Mappy</span>
              </div>
              <nav className="hidden md:flex items-center gap-4">
                <Button
                  variant="ghost"
                  onClick={() => navigate('/competitors')}
                >
                  Competitors
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => navigate('/brands')}
                >
                  Brands
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => navigate('/keyword-research')}
                >
                  Keywords
                </Button>
              </nav>
            </div>

            <div className="relative" ref={dropdownRef}>
              <button
                onClick={toggleDropdown}
                className="flex items-center gap-2 rounded-full focus:outline-none focus:ring-2 focus:ring-ring"
              >
                {user?.profile?.avatar ? (
                  <img
                    src={user.profile.avatar}
                    alt={user.username}
                    className="h-8 w-8 rounded-full"
                  />
                ) : (
                  <div className="h-8 w-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-medium">
                    {getInitials(user?.username)}
                  </div>
                )}
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 rounded-md border bg-card shadow-lg z-50">
                  <div className="p-2">
                    <div className="px-3 py-2 text-sm font-medium">
                      {user?.username}
                    </div>
                    <div className="h-px bg-border my-1" />
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-accent rounded-sm"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <main>
        {children}
      </main>
    </div>
  );
};

export default Layout;

